@if (isLoading) {
  <div class="cover-spin"></div>
}
@if (!verificationId) {
  <mat-card class="py-4 px-5 mt-5">
    <div class="py-1 px-3">
      <div
        class="h5 mt-3"
        [innerHTML]="'admin_portal.login.heading.content' | translate"
      ></div>
      <hr />
      <p [innerHTML]="'admin_portal.login.subheading.content' | translate"></p>
      <form class="mb-3" [formGroup]="loginForm" (ngSubmit)="onFormSubmit()">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label
            [innerHTML]="
              'admin_portal.login.login_form.username_form_field.label.content'
                | translate
            "
          ></mat-label>
          <input
            matInput
            formControlName="username"
            [errorStateMatcher]="matcher"
          />
          <mat-error>
            @if (
              !loginForm.get('username').valid &&
              loginForm.get('username').touched
            ) {
              <span
                [innerHTML]="
                  'admin_portal.login.login_form.username_form_field.error_message.content'
                    | translate
                "
              ></span>
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" appearance="outline">
          <mat-label
            [innerHTML]="
              'admin_portal.login.login_form.password_form_field.label.content'
                | translate
            "
          ></mat-label>
          <input
            type="password"
            matInput
            formControlName="password"
            [type]="hide ? 'password' : 'text'"
            [errorStateMatcher]="matcher"
          />
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>
            @if (
              !loginForm.get('password').valid &&
              loginForm.get('password').touched
            ) {
              <span
                [innerHTML]="
                  'admin_portal.login.login_form.password_form_field.error_message.content'
                    | translate
                "
              ></span>
            }
          </mat-error>
        </mat-form-field>
        <button
          class="w-100 mt-1 py-1"
          mat-raised-button
          type="submit"
          [disabled]="!loginForm.valid || isLoading"
          color="primary"
          [innerHTML]="
            'admin_portal.login.login_form.submit_button.content' | translate
          "
        ></button>
        @if (errorMessage) {
          <p class="error mt-3 text-center pt-0" [innerText]="errorMessage"></p>
        }
      </form>
      <div
        style="
          position: relative;
          z-index: 10;
          width: 100%;
          margin-top: 2em;
          margin-left: 2em;
          margin-right: auto;
        "
      >
        <div id="recaptcha-container"></div>
      </div>
    </div>
  </mat-card>
}
@if (verificationId && resolver) {
  <mat-card class="py-4 px-5 mt-5">
    <div class="py-1 px-3">
      <div
        class="h5 mt-3"
        [innerHTML]="
          'admin_portal.login.two_factor.heading.content' | translate
        "
      ></div>
      <hr />
      <p
        [innerHTML]="
          'admin_portal.login.two_factor.subheading1.content' | translate
        "
      ></p>
      <p
        [innerHTML]="
          ('admin_portal.login.two_factor.subheading2.first_part.content'
            | translate) +
          ' ' +
          getPhoneNumber() +
          ' ' +
          ('admin_portal.login.two_factor.subheading2.second_part.content'
            | translate)
        "
      ></p>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label
          [innerHTML]="
            'admin_portal.login.two_factor.verification_code_form.verification_code_form_field.label.content'
              | translate
          "
        ></mat-label>
        <input
          [(ngModel)]="verificationCode"
          matInput
          type="tel"
          pattern="[0-9]*"
          maxlength="6"
        />
      </mat-form-field>
      <button
        class="w-100 mt-1 py-1"
        (click)="verifySMSVerificationCode()"
        mat-raised-button
        [disabled]="isLoading || !(verificationCode.length === 6)"
        color="primary"
        [innerHTML]="
          'admin_portal.login.two_factor.verification_code_form.submit_button.content'
            | translate
        "
      ></button>
      @if (errorMessage) {
        <p class="error mt-3 text-center pt-0" [innerText]="errorMessage"></p>
      }
    </div>
  </mat-card>
}
